import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation, Trans } from 'react-i18next'
import Pagination from 'react-js-pagination'

const ListingReportsActions = ({
  data,
  columns,
  pagination,
  stateFilters,
  handleFilterChange,
  fiscalYears,
  taskGroups,
  statusList
}) => {
  const { t } = useTranslation()
  const tasksOnlyShow = [22, 25, 26, 48, 49, 50, 51]
  return (
    <Row>
      <Col>
        <Row className="d-flex">
          <Col md="2">
            <Form.Group>
              <Form.Label>{t('label:records per page')}:</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.per_page}
                onChange={(e) =>
                  handleFilterChange({ per_page: e.target.value, page: 1 })
                }
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="2">
            <Form.Group>
              <Form.Label>Atividade</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.__task_id}
                onChange={(e) => handleFilterChange({ __task_id: e.target.value, page: 1 })}
              >
                <option selected value="">Selecione a Atividade</option>
                {taskGroups.filter(g => g.tasks.filter(t => tasksOnlyShow.includes(t.id)).length > 0).map(group => (
                  <optgroup key={group.id} label={group.name}>
                    {group.tasks.filter(t => tasksOnlyShow.includes(t.id)).map(task => {
                      return <option key={task.id} value={task.id}>{ task.name }</option>
                    })}
                  </optgroup>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md="2">
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.__status_id}
                onChange={(e) => handleFilterChange({ __status_id: e.target.value, page: 1 })}
              >
                <option selected value="">Selecione o Status</option>
                {statusList.map(status => {
                  return <option key={status.id} value={status.id}>{ t(`statuses:${status.name}`) }</option>
                })}
              </Form.Control>
            </Form.Group>
          </Col>
          {/* <Col md="3">
            <Form.Group>
              <Form.Label>Ano Fiscal:</Form.Label>
              <Form.Control
                as="select"
                value={stateFilters.__fiscal_year}
                onChange={(e) =>
                  handleFilterChange({ __fiscal_year: e.target.value, page: 1 })
                }
              >
                <option disabled selected>Selecione o Ano fiscal</option>
                {fiscalYears.map(year => (
                  <option key={year}>{year}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col> */}
          <Col md={3} className="ml-2">
            <Form.Group>
              <Form.Label>{t('label:search')}:</Form.Label>
              <DebounceInput
                element={Form.Control}
                debounceTimeout={500}
                value={stateFilters.__search}
                onChange={(e) =>
                  handleFilterChange({ __search: e.target.value, page: 1 })
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <BootstrapTable
              columns={columns}
              id="funds-report-table"
              keyField="index"
              data={data}
              bordered hover responsive striped
              rowStyle={{ fontSize: '13px' }}
              noDataIndication="--"
              classes="table-condensed w-auto"
              wrapperClasses='table-responsive'
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Trans i18nKey="label:interpolateShowingRecords">
              Showing {{ from: pagination.from || '0' }} to{' '}
              {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
              records
            </Trans>
          </Col>
          <Col className="d-flex justify-content-end">
            <Pagination
              activePage={pagination.current_page}
              itemsCountPerPage={pagination.per_page}
              totalItemsCount={pagination.total}
              pageRangeDisplayed={5}
              onChange={(page) => handleFilterChange({ page })}
              itemClass="page-item"
              linkClass="page-link"
              prevPageText="‹"
              nextPageText="›"
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ListingReportsActions;